export enum DateFilterOptionTypes {
  // All available dates
  allAvailable = 'all_available',
  // Just the latest datetime
  latest = 'latest'
}
